// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AvailabilityQuickCopyPage_container__r-0Pp {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 200px);
  text-align: center;
  padding: 2rem;
}
.AvailabilityQuickCopyPage_container__r-0Pp .AvailabilityQuickCopyPage_title__i09bp {
  margin-top: 2rem;
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--primary-color, #333);
}
.AvailabilityQuickCopyPage_container__r-0Pp .AvailabilityQuickCopyPage_subtitle__8Sbkx {
  margin-top: 1rem;
  font-size: 1rem;
  color: var(--text-secondary, #666);
  max-width: 400px;
}`, "",{"version":3,"sources":["webpack://./src/pages/AvailabilityQuickCopyPage/AvailabilityQuickCopyPage.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;EACA,kBAAA;EACA,aAAA;AACJ;AACI;EACI,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iCAAA;AACR;AAEI;EACI,gBAAA;EACA,eAAA;EACA,kCAAA;EACA,gBAAA;AAAR","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: calc(100vh - 200px);\n    text-align: center;\n    padding: 2rem;\n\n    .title {\n        margin-top: 2rem;\n        font-size: 1.5rem;\n        font-weight: 600;\n        color: var(--primary-color, #333);\n    }\n\n    .subtitle {\n        margin-top: 1rem;\n        font-size: 1rem;\n        color: var(--text-secondary, #666);\n        max-width: 400px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AvailabilityQuickCopyPage_container__r-0Pp`,
	"title": `AvailabilityQuickCopyPage_title__i09bp`,
	"subtitle": `AvailabilityQuickCopyPage_subtitle__8Sbkx`
};
export default ___CSS_LOADER_EXPORT___;
